<!--
 * @Author: 曹捷
 * @Date: 2021-01-27 10:49:57
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-09 16:42:36
 * @Description: 经典布局  左侧菜单
 右侧上下分别是  head body  foot
-->
<template>
  <a-layout class="layoutLeft">
    <a-layout-sider width="72" v-if="userInfo.tenantSuperUser" v-show="!fullPage">
      <mainMenu></mainMenu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header v-if="config.header.fixed" v-show="!fullPage" :style="{
          height: config.header.height + 'px',
          'line-height': config.header.height + 'px'}">
        <slot name="header"></slot>
      </a-layout-header>
      <a-layout>
        <slider v-if="hasMenu" v-show="!fullPage">
          <slot name="menu"></slot>
        </slider>
        <a-layout-content class="h100">
          <slot name="body"></slot>
        </a-layout-content>
        <a-layout-footer v-if="config.foot.fixed">
          <slot name="foot"></slot>
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import slider from './compoents/layout-sider.vue'
import mainMenu from './compoents/mainMenu.vue'
import { useStore } from 'vuex'
import { computed, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { userRole } from 'obit-wui/utils/auth'
export default {
  components: {
    slider, mainMenu
  },
  props: {
    fullPage: {
      type: Boolean
    }
  },
  setup () {
    let store = useStore()
    let route = useRoute()
    let _data = reactive({
      userInfo: userRole.get()
    })
    let _computed = {
      config: computed(() => store.state.settings),
      routeMate: computed(() => route.meta),
      hasMenu: computed(() => {
        return !(route.path === '/' || route.path.indexOf('/main') === 0)
      })
    }

    return {
      ...toRefs(_data),
      ..._computed
    }
  }
}
</script>

<style lang="less">
.layoutLeft {
  .ant-menu-submenu-title {
    // padding-left: 50px !important;
  }
}
</style>